import { IApproval, IApprovalDetail, ICompliance, ISailPointCertDetails, ITaskDetail } from '@/types/tasksApprovals'

import Default from './layouts/default'
import NoApproveRejectButtons from './layouts/noApproveRejectButtons'
import SailPointCertificatesDecision from './layouts/sailPointCertificatesDecision'
import SapGrcRoleAccess from './layouts/sapGrcRoleAccess'

const Container = ({
    item,
    itemDetails,
    itemId,
    onClose,
}: {
    item: ICompliance | IApproval
    itemDetails: ITaskDetail | IApprovalDetail | ISailPointCertDetails[] | null
    itemId: string
    onClose: () => void
}) => {
    switch (item.system_id) {
        case 'SAIL_POINT_CERT_DECISION':
            return <SailPointCertificatesDecision itemId={itemId} onClose={onClose} />
        case 'MY_LEARNING':
        case 'MY_LEARNING_RO':
        case 'SERVICE_NOW_CHANGES':
        case 'SCHEDULED_CHANGE_REQUESTS':
        case 'WORKDAY_LEAVE_TASKS':
            return <NoApproveRejectButtons item={item} itemDetails={itemDetails as ITaskDetail | IApprovalDetail} onClose={onClose} />
        case 'SAP_GRC_ACCESS_REQUEST':
            return <SapGrcRoleAccess itemDetails={itemDetails as IApprovalDetail} itemId={itemId} onClose={onClose} />
        default:
            return <Default item={item} itemDetails={itemDetails} onClose={onClose} />
    }
}

export default Container
